<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <div
      class="col-xs-12 mycol content-mb-14"
      v-show="isShowPunct()"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_PERIOD_START'
        )
      }"
    >
      <p class="content-s-2-label">
        <label v-if="$parent.$parent.getProgramCode() === 'improving_ecology'"
          >Завершение мероприятий по снижению выбросов / сбросов загрязняющих
          веществ, мес.:</label
        >
        <label v-else
          >Период запуска серийного производства (с даты получения займа),
          мес.:</label
        >
      </p>
      <!--   начало блока подсказки   -->
      <div class="info-holder-container i-wid-29">
        <div
          v-if="
            $parent.project.UF_HELP.FIELDS &&
              $parent.project.UF_HELP.FIELDS.STEP2.UF_PERIOD_START &&
              $parent.$parent.getProgramCode() !== 'improving_ecology'
          "
        >
          <div
            class="info-holder-icon info-holder-icon_inp"
            style="right: 20px"
          />
          <div class="info-holder-content info-holder-content_inp">
            <div class="info-holder-content__text">
              {{ $parent.project.UF_HELP.FIELDS.STEP2.UF_PERIOD_START }}
            </div>
          </div>
        </div>
        <div
          v-else-if="$parent.$parent.getProgramCode() !== 'improving_ecology'"
        >
          <div class="info-holder-icon info-holder-icon_inp" />
          <div class="info-holder-content info-holder-content_inp">
            <div class="info-holder-content__text">
              За прогнозную дату получения займа рекомендуем принять 16-е число
              второго месяца планируемого квартала получения займа
            </div>
          </div>
        </div>
        <!--   конец блока подсказки   -->
        <input
          type="text"
          v-on:keyup="
            $parent.$parent.removeError('PROJECTS', 'LOGIC', 'UF_PERIOD_START')
          "
          v-on:keypress="isNumber($event)"
          v-model="$parent.project.UF_PERIOD_START"
          class="i-main-style i-wid-100"
          :disabled="$parent.$parent.projectDisabled"
        />
      </div>
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText("PROJECTS", "LOGIC", "UF_PERIOD_START")
        }}
      </div>
    </div>

    <div
      class="col-xs-12 mycol content-mb-14"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_RESULT_NATURAL'
        )
      }"
    >
      <p class="content-s-2-label">
        <label v-if="$parent.$parent.getProgramCode() === 'improving_ecology'"
          >Предполагаемый уровень снижения выбросов / сбросов загрязняющих
          веществ:</label
        >
        <label v-else
          >Результат от реализации проекта в натуральном выражении:</label
        >
      </p>
      <!--   начало блока подсказки   -->
      <div class="info-holder-container_ i-wid-29">
        <!--<div
            v-if="
            $parent.project.UF_HELP.FIELDS &&
              $parent.project.UF_HELP.FIELDS.STEP2.UF_PERIOD_START &&
              $parent.$parent.getProgramCode() !== 'improving_ecology'
          "
        >
          <div
              class="info-holder-icon info-holder-icon_inp"
              style="right: 20px"
          />
          <div class="info-holder-content info-holder-content_inp">
            <div class="info-holder-content__text">
              {{ $parent.project.UF_HELP.FIELDS.STEP2.UF_PERIOD_START }}
            </div>
          </div>
        </div>
        <div
            v-else-if="$parent.$parent.getProgramCode() !== 'improving_ecology'"
        >
          <div class="info-holder-icon info-holder-icon_inp"/>
          <div class="info-holder-content info-holder-content_inp">
            <div class="info-holder-content__text">
              За прогнозную дату получения займа рекомендуем принять 16-е число
              второго месяца планируемого квартала получения займа
            </div>
          </div>
        </div>
        <!- -   конец блока подсказки   -->
        <input
          v-on:keyup="
            $parent.$parent.removeError(
              'PROJECTS',
              'LOGIC',
              'UF_RESULT_NATURAL'
            )
          "
          type="text"
          class="i-main-style i-wid-100"
          v-model="$parent.project.UF_RESULT_NATURAL"
          :disabled="$parent.$parent.projectDisabled"
        />
      </div>
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText(
            "PROJECTS",
            "LOGIC",
            "UF_RESULT_NATURAL"
          )
        }}
      </div>
    </div>
    <p
      v-if="
        //$parent.programCode($parent.project.UF_SUPPORT_PROG_ID) === 'improving_ecology'
        $parent.$parent.getProgramCode() === 'improving_ecology'
      "
    >
      В данном поле необходимо указать планируемый объем снижения выбросов
      загрязненных сточных вод в куб. м и процентах / загрязняющих веществ в
      атмосферу в тоннах и процентах за весь срок реализации проекта.
      <br />Например, cнижение выбросов оксида азота на 300 тыс. тонн (на 25%) к
      2024 г.
    </p>
    <p class="content-info-text" v-else>
      В данном поле необходимо указать планируемый объем производимой продукции
      в соответствующих единицах измерения и с указанием продукта проекта за
      период пользования займом Фонда. Например, 20 000 фрез или 15 тыс. тонн
      резиновой крошки.
    </p>
  </div>
</template>

<script>
export default {
  name: "uf_result_natural",
  methods: {
    isNumber: function(evt) {
      if (parseInt(this.$parent.project.UF_VERSION_SHIFR_PRD) > 2) {
        //проверка ввода чисел привязали с вводом нового шифра продукции
        evt = evt ? evt : window.event;
        let charCode = evt.which ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
          evt.preventDefault();
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    isShowPunct() {
      if (
        this.$parent.$parent.getProgramCode() !== "lekarstva" &&
        this.$parent.$parent.getProgramCode() !== "cifrovizaciya" &&
        this.$parent.$parent.getProgramCode() !== "component_and_resource_base"
      ) {
        if (
          this.$parent.$parent.getProgramCode() ===
            "providing_mobilization_needs" &&
          this.$parent.project.UF_SETTING
            .IS_HIDE_PERIOD_START_PROVIDING_MOBILIZATION_NEEDS == 1
        ) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    }
  }
};
</script>

<style scoped></style>
